module.exports = __webpack_public_path__ + "img/logo.04b0e049.svg";